<header class="d-flex align-items-center justify-content-between mb-3 flex-wrap">
  <div>
    <h1 class="h3 mb-0">{{title}}</h1>
  </div>
  <ul class="nav nav-tabs" role="tablist" aria-label="Administrative Tabs">
    <li class="nav-item" role="presentation">
      <a class="nav-link" [class.active]="activeTab === ''" href="#" (click)="selectTab('', $event)">Dashboard</a>
    </li>
    <li class="nav-item" role="presentation" *ngIf="permissions && permissions.includes('audit_trail')">
      <a class="nav-link" [class.active]="activeTab === 'audit_trail'" href="#" (click)="selectTab('audit_trail', $event)">Audit Trail</a>
    </li>
    <li class="nav-item" role="presentation">
      <a class="nav-link" [class.active]="activeTab === 'manual_notifications'" href="#" (click)="selectTab('manual_notifications', $event)">Manual Notifications</a>
    </li>
  </ul>
</header>
